export default {
  ho: "allowCrawlerActivity",
  Eo: "baseUrl",
  _o: "noCookies",
  Io: "devicePropertyAllowlist",
  Aa: "disablePushTokenMaintenance",
  Ao: "enableLogging",
  So: "enableSdkAuthentication",
  qa: "manageServiceWorkerExternally",
  No: "minimumIntervalBetweenTriggerActionsInSeconds",
  wo: "sessionTimeoutInSeconds",
  Oo: "appVersion",
  Po: "appVersionNumber",
  _a: "serviceWorkerLocation",
  ka: "safariWebsitePushId",
  Ba: "localization",
  po: "contentSecurityNonce",
  Ro: "enableHtmlInAppMessages",
  Co: "allowUserSuppliedJavascript",
  lo: "inAppMessageZIndex",
  fo: "openInAppMessagesInNewTab",
  en: "openNewsFeedCardsInNewTab",
  mh: "requireExplicitInAppMessageDismissal",
  Lo: "doNotLoadFontAwesome",
  Mo: "sdkFlavor",
  tn: "openCardsInNewTab",
};
